import React, { useEffect } from "react";
import { apiAsia } from "../../utils/api-asia";
import UseQuery from "../../utils/useQuery";

const VisitSum = _ => {
  useEffect(v=>{
    const query = UseQuery();
    if(query.returnUrl){
      visit()
    }else{
      window.location.href = '/'
    }
  },[])
  const visit = _ => {
    const query = UseQuery();
    if(query.skey && query.act !== 'unsub'){
      apiAsia.form.visit({skey: query.skey}).then(res => {
          window.location.href = query.returnUrl
      })
    }
    if(query.act || query.act == 'unsub'){
      window.location.href = query.returnUrl
    }
  }
  
  return (
		<div className="VisitSum"></div>
  );
};
export default VisitSum;
